import React from "react"

import { useStore } from "@/store"

const TableColumn = ({ table: _table }) => {
  const { calendarDimensions } = useStore()

  return (
    <div
      className="flex-1 border-0 border-r border-solid border-gray-300"
      style={{ width: calendarDimensions.columnWidth, height: "100%" }}
    />
  )
}

const TablesLayer = ({ tables }) => {
  const { calendarDimensions } = useStore()

  return (
    <div
      className="flex flex-1 flex-row min-w-min touch-none pointer-events-none"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: calendarDimensions.canvas.width,
        height: calendarDimensions.canvas.height,
      }}
      data-testid="panel-reservations-calendar-tables-layer"
    >
      {tables.map((table) => (
        <TableColumn key={table.id} table={table} />
      ))}
    </div>
  )
}

export default TablesLayer
